/**
 * Safely centralized wrappers around browser localStorage.
 *
 * Notes:
 * - These helpers intentionally do not catch errors. Keep behavior identical to direct localStorage usage.
 */

/**
 * Read a value from localStorage.
 *
 * @param {string} key
 * @returns {string|null}
 */
export function lsGet (key) {
    return localStorage.getItem(key);
}

/**
 * Remove a key from localStorage.
 *
 * @param {string} key
 * @returns {void}
 */
export function lsRemove (key) {
    localStorage.removeItem(key);
}
